import { TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useCandidatesResultsContext } from '../../../Contexts/CandidateResultsContext';
import TabPaper from '../../Common/TabPaper';
import NoteRTE from './NoteRTE';
import { CandidatesNoteForm, useCandidatesNoteForm } from './useCandidatesNoteForm';
import UIStrings from '@/Utils/UIStrings';

function NotesTab() {
    const { results, updateNoteAsync } = useCandidatesResultsContext();
    const form = useCandidatesNoteForm();
    const [saved, setSaved] = useState<boolean>(false);
    const [errorSaving, setErrorSaving] = useState<boolean>(false);

    const { applicantProfile } = results;

    const saveCandidatesNote = async (values: CandidatesNoteForm) => {
        let success = true;

        try {
            setSaved(false);
            setErrorSaving(false);
            await updateNoteAsync(values.noteRte);
        } catch {
            setErrorSaving(true);
            success = false;
        } finally {
            if (success) {
                setSaved(true);
            }
        }
    };

    return (
        <TabPaper data-cy="NotesTab">
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <TypographyH3 className="text-foreground text-xl">
                        {UIStrings.InterviewNotesAndHighlightsForApplicantName(applicantProfile.name)}
                    </TypographyH3>
                    <TypographyP className="text-foreground text-base">
                        {UIStrings.PleaseUseThisSectionToSummarizeTheKeyPoints}
                    </TypographyP>
                </div>
                <FormProvider {...form}>
                    <form onSubmit={form.handleSubmit(saveCandidatesNote)}>
                        <NoteRTE saved={saved} errorSaving={errorSaving} />
                    </form>
                </FormProvider>
            </div>
        </TabPaper>
    );
}

export default NotesTab;
